import React, { useState } from 'react';
import { Archive, FileSearch, CheckCircle2 } from 'lucide-react';
import TrivialIssuesPanel from './archived/TrivialIssuesPanel';
import ClosedInvestigationsPanel from './archived/ClosedInvestigationsPanel';
import CompletedTasksPanel from './archived/CompletedTasksPanel';

type SubKey = 'trivial' | 'closed' | 'completed';

const SECTIONS: { key: SubKey; label: string; icon: React.ElementType }[] = [
    { key: 'trivial',    label: 'Trivial Issues',         icon: Archive },
    { key: 'closed',     label: 'Closed Investigations',  icon: FileSearch },
    { key: 'completed',  label: 'Completed Tasks',        icon: CheckCircle2 },
];

const ArchivedTab: React.FC = () => {
    const [sub, setSub] = useState<SubKey>('trivial');

    return (
        <div className="flex h-full overflow-hidden">
            <div className="netbody-card side-nav-card">
                <div className="side-nav-card-heading">Archive</div>
                <nav aria-label="Archive sub-view">
                    {SECTIONS.map(({ key, label, icon: Icon }) => (
                        <button
                            key={key}
                            onClick={() => setSub(key)}
                            className={`side-panel-menu-item${sub === key ? ' side-panel-menu-item--active' : ''}`}
                            data-testid={`NAV_capa_archived_${key}`}
                        >
                            <Icon size={14} />
                            {label}
                        </button>
                    ))}
                </nav>
            </div>
            <div className="flex-1 min-w-0">
                {sub === 'trivial' && <TrivialIssuesPanel />}
                {sub === 'closed' && <ClosedInvestigationsPanel />}
                {sub === 'completed' && <CompletedTasksPanel />}
            </div>
        </div>
    );
};

export default ArchivedTab;
